import React from 'react'

const InOut = ({ color, size}) => {
    return (
        <svg className={`size-${size || 6}`} width="800px" height="800px" viewBox="0 0 24 24" fill="none" stroke={`${color}`} stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 2v14a2 2 0 0 0 2 2h14" />
            <path d="M18 22V8a2 2 0 0 0-2-2H2" />
            <circle cx="6" cy="2" r="1" fill={color || "white"} />
            <circle cx="18" cy="22" r="1" fill={color || "white"} />
        </svg>

    )
}

export default InOut